import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectMFControlPanelVariable } from 'redux/reducers/meteorologyFieldsControlPanelReducer';
import { ControlPanelOption, Model } from 'helper/products/meteorology';
import { HEATMAP_MODELS } from 'helper/products/meteorology/heatmapModels';

export type ViewMode = 'heatmap' | 'spatial';

export default function useVariables(
  models: Model[],
  getModelOptions: (modelValue: string) => ControlPanelOption,
  viewMode: ViewMode,
) {
  const variable = useSelector(selectMFControlPanelVariable);

  const uniqueVariables = useMemo(() => (
    models
      .map((m) => getModelOptions(m.value))
      .flatMap((o) => o.variables)
      .filter((var1, i, arr) => arr.findIndex((var2) => var1.id === var2.id) === i)
  ), [models, getModelOptions]);

  const selectableModels = useMemo(() => {
    const byVariable = models.filter((m) => (
      getModelOptions(m.value)
        .variables
        .some((v) => v.id === variable)
    ));
    if (viewMode === 'heatmap') {
      return byVariable.filter((m) => (HEATMAP_MODELS as readonly string[]).includes(m.value));
    }
    return byVariable;
  }, [models, getModelOptions, variable, viewMode]);

  return {
    variables: uniqueVariables,
    selectableModels,
  };
}
